module.exports = __webpack_public_path__ + "static/live_hero-852da0301a6ff967cdb328560b47fa8c.jpg";